/// <amd-module name="Tfs/Frame/Components/Header/ProjectHeader" />
import * as React from "react";

import { Components, RegionComponent } from "VSS/Platform/Layout";
import { WithHeaderProgressBar } from "./WithHeaderProgressBar";

import { FocusZone, FocusZoneDirection } from "VSSUI/FocusZone";
import * as Resources from "Tfs/Frame/Resources";

class ProjectHeader extends React.Component<{}> {
    public render(): JSX.Element {
        return (
            <FocusZone circularNavigation={true} direction={FocusZoneDirection.Horizontal} focusGroupProps={{ defaultElementId: "suite-logo" }}>
                <div className="project-header flex-row flex-noshrink">
                    <WithHeaderProgressBar>
                        <div className="flex-row flex-grow">
                            <RegionComponent className="flex-row flex-grow" aria-label={Resources.AzureDevopsNavigationAriaLabel} componentRegion="header" role="navigation" />
                            <RegionComponent className="flex-row flex-noshrink" componentRegion="header-menubar" role="menubar" />
                        </div>
                    </WithHeaderProgressBar>
                </div>
            </FocusZone>
        );
    }
}

Components.add("ms.vss-tfs-web.frame.project-header", ProjectHeader);
